import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const NATModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Network Address Translation (NAT)"
    videos={[
      "https://www.youtube.com/embed/47PUj7OSGkA"
    ]}
    takeaways={[]}
    questions={[
      "What is NAT? What are the situations where Network Address Translations are required?"
    ]}
    exampleVideos={[]}
  />
);
}

export default NATModule;
